/**
 * @flow
 * @relayHash 479830d2c8e2084a1ea5d7c39e4f095d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectWarehouseLocationFieldQueryVariables = {|
  search?: ?string
|};
export type SelectWarehouseLocationFieldQueryResponse = {|
  +warehouseLocations: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +code: ?string,
      |}
    |}>
  |}
|};
export type SelectWarehouseLocationFieldQuery = {|
  variables: SelectWarehouseLocationFieldQueryVariables,
  response: SelectWarehouseLocationFieldQueryResponse,
|};
*/


/*
query SelectWarehouseLocationFieldQuery(
  $search: String
) {
  warehouseLocations(first: 300, search: $search) {
    edges {
      node {
        id
        name
        code
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "warehouseLocations",
    "storageKey": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 300
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "WarehouseLocationConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "WarehouseLocationEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectWarehouseLocationFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectWarehouseLocationFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectWarehouseLocationFieldQuery",
    "id": null,
    "text": "query SelectWarehouseLocationFieldQuery(\n  $search: String\n) {\n  warehouseLocations(first: 300, search: $search) {\n    edges {\n      node {\n        id\n        name\n        code\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c3f9a3058eb25d8455d702a15572ae3';
module.exports = node;
